import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import Layout from "../../../components/dashboard/Layout";
import AddGroup from "../../../containers/superadmin/groups/models/add-group";
import SearchBar from "../../../containers/superadmin/groups/searchbar";
import GroupsTable from "../../../containers/superadmin/groups/table";
import {
  getAllGroupsRequest,
  getCourseGroupRequest,
} from "../../../modules/superadmin-modules/groups/Actions";
const SuperadminGroups = () => {
  const dispatch = useDispatch();
  const [isAdd, setAdd] = useState(false);
  const [selectedData, setSelectedData] = useState({});
  const [courseId, setCourseId] = useState(null);

  useEffect(() => {
    if (courseId) dispatch(getCourseGroupRequest(courseId));
    else dispatch(getAllGroupsRequest());
  }, [courseId]);

  return (
    <Layout>
      <SearchBar setAdd={setAdd} setCourseId={setCourseId} />
      <GroupsTable setAdd={setAdd} setSelectedData={setSelectedData} />
      <AddGroup
        isAdd={isAdd}
        data={selectedData}
        setSelectedData={setSelectedData}
      />
    </Layout>
  );
};

export default SuperadminGroups;
